import { render } from "./SearchSort.vue?vue&type=template&id=4e553263"
import script from "./SearchSort.vue?vue&type=script&lang=js"
export * from "./SearchSort.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__